module.exports = __webpack_public_path__ + "img/chr_ts_10_penlight.09c364c6.png";